import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useEffect, useState, useRef, useCallback } from "react";
import InputField from "../InputField";
import defaultValues from "../../constant/defaultValues";
import { connect } from "react-redux";
import { getCountryList } from "../../actions/defaultDataAction";
import errorMessages from "../../constant/errorMessages";
import API_URL from "../../constant/api.config";
import {
  setAuthHeaders,
  showErrorMessage,
  showSuccessMessage,
} from "../../utils/common";
import { useAuth } from "../../AuthProvider";
import axiosHttp from "../../axiosHttp";
import ButtonCancell from "../ButtonCancell";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { cloneDeep, filter, isEmpty, map, size, trim } from "lodash";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
  Table,
  TableToolbar,
  TableProperties,
  TableCellProperties,
  TableColumnResize,
} from "ckeditor5";
import CheckBox from "../CheckBox";
import { getCompaniesByCountry } from "../../actions/memberAction";
import regExpressions from "../../constant/regExpressions";
import axios from "axios";
import { encode } from "js-base64";
import regExp from "../../constant/regExpressions";
import Choosefile from "../../components/Choosefile";
import pdf from "../../images/sidebarImages/pdf_icon.svg";
import word from "../../images/word.webp";
import excel from "../../images/excel.webp";
import AirFreight from "./Logistic/AirFreight";
import RoadFreight from "./Logistic/RoadFreight";
import DAPFreight from "./Logistic/DAPFreight";
import SeaFreight from "./Logistic/SeaFreight";

const FILE_SLOTS = ["FILE1", "FILE2"];
const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
const ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "text/csv",
];
const EXT_CATEGORY = {
  pdf: "pdf",
  doc: "word",
  docx: "word",
  xls: "excel",
  xlsx: "excel",
  csv: "excel",
  jpg: "image",
  jpeg: "image",
  png: "image",
  webp: "image",
};
const LogisticInquiry = (props) => {
  const { user, isDemoUser, isSuperAdmin, isViewer, isInqUser, isEndUser } =
    useAuth();
  const { EMAIL_FIELD_MAX_LENGTH } = defaultValues;
  const [verrors2, setVErrors2] = useState({});
  const [selectedCbpp, setSelectedCbpp] = useState(null);

  const initialState = {
    company_name:
      isSuperAdmin || isViewer || isInqUser ? "" : user.company_name,
    contact_person: isSuperAdmin || isViewer || isInqUser ? "" : user.name,
    email: isSuperAdmin || isViewer || isInqUser ? "" : user.email,
    phone: "",
    industry: "",
    country: "",
    product: "",
    quantity: "",
    unit: "",
    message: "",
    country_from: "",
    country_from_id: "",
    country_to: "",
    country_to_id: "",
    freight_type: "",
    port_of_destination: "",
    port_of_origin: "",
    ocean_type: "",
    lwh: "",
    cbpp: "",
    total_weight: "",
    term: "",
    pickup_address: "",
    delivery_address: "",
    no_of_containers: "",
    type: "Logistic_Partner",
    commodity: "",
    emailIds: "",
    member_id:
      user && isDemoUser
        ? parseInt(props.member_id)
        : parseInt(props.member_id),
    inquiry_type:
      props.inq_type !== undefined && props.inq_type !== null
        ? props.inq_type
        : user && isDemoUser
          ? "DEMO"
          : "USER",
    assignCompany: null,
    assignCountry: null,
    lwh_qty_packaging: [
      {
        lwh: " ",
        no_qty: " ",
        cbpp: " ",
      },
    ],
  };

  const invalidEmails = defaultValues.IGNORE_EMAILS;
  let inqType =
    props.inq_type !== undefined && props.inq_type !== null
      ? props.inq_type
      : null;

  const [formData, setFormData] = useState(initialState);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountryFrom, setSelectedCountryFrom] = useState(null);
  const [selectedCountryTo, setSelectedCountryTo] = useState(null);
  const [selectedFreightType, setSelectedFreightType] = useState(null);
  const [selectedOceanType, setSelectedOceanType] = useState(null);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [phoneValue, setphoneValue] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [assignCountry, setAssignCountry] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [assignCompany, setAssignCompany] = useState(null);
  const [memberOptLoader, setMemberOptLoader] = useState(false);
  const [portOfOriginList, setPortOfOriginList] = useState([]);
  const [portOfDestinationList, setPortOfDestinationList] = useState([]);
  const [selectedPortOfOrigin, setSelectedPortOfOrigin] = useState(null);
  const [selectedPortOfDestination, setSelectedPortOfDestination] =
    useState(null);
  const [originLoader, setOriginLoader] = useState(false);
  const [destinationLoader, setDestinationLoader] = useState(false);
  const [portLabel, setPortLabel] = useState("Port");

  const freightTypeList = defaultValues.FREIGHT_TYPE;

  const showPickupAddress = [
    "EXW (Ex-Works or Ex-Warehouse)",
    "FCA (Free to Carrier)",
  ];
  const showDeliveryAddress = [
    "CPT (Carriage Paid To)",
    "CIP (Carriage And Insurance Paid To)",
    "DAP (Delivered At Place)",
    "DDP (Delivered Duty Paid)",
  ];

  const [assignCountryCompany, setAssignCountryCompany] = useState([
    {
      country_id: 0,
      member_id: 0,
      country: null,
      company: null,
      companyList: [],
    },
  ]);

  const style2 = {
    height: "120px",
    width: "120px",
  };

  const [file2, setFile2] = useState({});
  const fileRefs = {
    FILE1: useRef(null),
    FILE2: useRef(null),
    FILE3: useRef(null),
  };
  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleCountryFromChange = (cval) => {
    const type = "countryFrom";
    const countryId = cval.value;
    setSelectedCountryFrom(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_from: countryId,
        country_from_id: cval.country_id,
        port_of_origin: "",
        isNewValOrigin: false,
      };
    });
    setSelectedPortOfOrigin(null);
    fetchCountryPorts(cval.country_id, type);
  };

  const handleCountryToChange = (cval) => {
    const countryId = cval.value;
    const type = "countryTo";
    setSelectedCountryTo(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_to: countryId,
        country_to_id: cval.country_id,
        port_of_destination: "",
        isNewValDestination: false,
      };
    });
    setSelectedPortOfDestination(null);
    fetchCountryPorts(cval.country_id, type);
  };

  const handleFreightTypeChange = (cval) => {
    const freightTypeId = cval.value;
    setSelectedFreightType(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        freight_type: freightTypeId,
        port_of_origin: "",
        port_of_destination: "",
        isNewValOrigin: false,
        isNewValDestination: false,
      };
    });

    setSelectedOceanType(null);

    setSelectedPortOfOrigin(null);
    setSelectedPortOfDestination(null);

    if (cval.value === "Air") {
      setPortLabel("Air");
    } else {
      setPortLabel("Port");
    }

    let errObj = { ...errors };

    errObj[`ocean_type`] = "";
    // errObj[`commodity`] = "";

    if (freightTypeId == "Road") {
      errObj[`country_from`] = "";
      errObj[`country_to`] = "";
      errObj[`no_of_containers`] = "";
      errObj[`lwh`] = "";
      errObj[`cbpp`] = "";
      errObj[`port_of_origin`] = "";
      errObj[`port_of_destination`] = "";
      errObj[`lwh_qty_packaging`] = [];
      errObj[`term`] = "";
    }

    setErrors(errObj);
  };

  const handleOceanTypeChange = (cval) => {
    const oceanTypeId = cval.value;
    setSelectedOceanType(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        ocean_type: oceanTypeId,
      };
    });
    if (formData.freight_type == "DAP") {
      if (oceanTypeId === "LCL") {
        setErrors((prev) => ({ ...prev, no_of_containers: "" }));
      }

      if (oceanTypeId === "Ro-Ro") {
        setErrors((prev) => ({ ...prev, no_of_containers: "", cbpp: "" }));
      }

      if (oceanTypeId === "Project_Cargo") {
        setErrors((prev) => ({ ...prev, cbpp: "" }));
      }
    }

    if (formData.freight_type == "Ocean") {
      if (oceanTypeId === "LCL") {
        setErrors((prev) => ({ ...prev, no_of_containers: "" }));
      }

      if (oceanTypeId === "Ro-Ro") {
        setErrors((prev) => ({ ...prev, no_of_containers: "", cbpp: "" }));
      }

      if (oceanTypeId === "Project_Cargo") {
        setErrors((prev) => ({ ...prev, cbpp: "" }));
      }

      if (oceanTypeId === "Bulk") {
        setErrors((prev) => ({ ...prev, no_of_containers: "", cbpp: "" }));
      }
    }
  };

  const handleTermChange = (cval) => {
    setErrors((prevalue) => {
      return {
        ...prevalue,
        pickup_address: "",
        delivery_address: "",
      };
    });

    const termId = cval.value;
    setSelectedTerm(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        term: termId,
        pickup_address: "",
        delivery_address: "",
      };
    });
  };

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  };

  const handleFocusOut = async (e) => {
    let flag = 0;
    let er = { ...errors };

    if (e.target.name === "company_name") {
      if (e.target.value === "") {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExpCompanyName = regExpressions.company_name;
        const check = regExpCompanyName.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.company_name = "";
        }
      }
    }

    if (e.target.name === "contact_person") {
      if (e.target.value === "") {
        flag = 1;
        er.contact_person = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 50) {
        flag = 1;
        er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        const regExpName = regExpressions.name;
        const check = regExpName.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.contact_person = "";
        }
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        // const currentEmail = e.target.value.split("@")[1];
        // const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // const check = regExp.test(e.target.value);
        // if (check === false) {
        //     flag = 1;
        //     er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        // } else if (invalidEmails.includes(currentEmail)) {
        //     flag = 1;
        //     er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        // } else {
        flag = 0;
        er.email = "";
        //}
      }
    }

    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      let numberWithoutCountryCode = phoneValue
        .replace(/^\+(\d{1,4})\s?/, "")
        .replace(/\s/g, "");
      if (numberWithoutCountryCode === "+") {
        flag = 0;
        er.phone = "";
      }
      if (
        phoneValue !== "" &&
        phoneValue.length > 4 &&
        numberWithoutCountryCode > 0
      ) {
        if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.phone = "";
        }
      }
    }

    if (e.target.name === "country_from") {
      if (e.target.value === "") {
        flag = 1;
        er.country_from = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country_from = "";
      }
    }

    if (e.target.name === "country_to") {
      if (e.target.value === "") {
        flag = 1;
        er.country_to = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country_to = "";
      }
    }

    if (e.target.name === "ocean_type") {
      if (e.target.value === "") {
        flag = 1;
        er.ocean_type = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.ocean_type = "";
      }
    }

    if (e.target.name === "no_of_containers") {
      let no = e.target.value;
      let noReg = regExpressions.inquiry.no_of_containers;
      if (
        (selectedFreightType && selectedFreightType.value == "Road") ||
        (selectedOceanType &&
          (selectedOceanType.value == "FCL" ||
            selectedOceanType.value == "Project_Cargo" ||
            selectedOceanType.value == "DAG_GOODS" ||
            selectedOceanType.value == "LCL_FCL"))
      ) {
        if (e.target.value == "") {
          flag = 1;
          er.no_of_containers = errorMessages.FIELD_REQUIRED;
        } else if (e.target.value !== "" && no.length > 0) {
          if (no.length > 150) {
            flag = 1;
            er.no_of_containers = errorMessages.MAX_LENGTH_150_EXCEEDED;
          } else {
            const check = noReg.test(e.target.value);
            if (check === false) {
              flag = 1;
              er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              flag = 0;
              er.no_of_containers = "";
            }
          }
        }
      }

      if (
        selectedOceanType &&
        (selectedOceanType.value == "LCL" ||
          selectedOceanType.value == "Ro-Ro" ||
          selectedOceanType.value == "Bulk")
      ) {
        if (e.target.value !== "" && no.length > 0) {
          if (no.length > 150) {
            flag = 1;
            er.no_of_containers = errorMessages.MAX_LENGTH_150_EXCEEDED;
          } else {
            const check = noReg.test(e.target.value);
            if (check === false) {
              flag = 1;
              er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              flag = 0;
              er.no_of_containers = "";
            }
          }
        }
      }

      /*const isBulk = formData.ocean_type === "Bulk";
      const isFCL = formData.ocean_type === "FCL";
      const isRequired = !isBulk;
      let no = e.target.value;
      let noReg = regExpressions.inquiry.no_of_containers;
      if (isFCL && e.target.value === "") {
        flag = 1;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 20) {
          flag = 1;
          er.no_of_containers = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.no_of_containers = "";
          }
        }
      } else {
        flag = 0;
        er.no_of_containers = "";
      } */
    }

    if (e.target.name === "lwh") {
      let no = e.target.value;
      let noReg =
        /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;
      if (e.target.value === "") {
        flag = 1;
        er.lwh = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 50) {
          flag = 1;
          er.lwh = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.lwh = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.lwh = "";
          }
        }
      }
    }

    if (e.target.name === "commodity") {
      if (e.target.value === "") {
        flag = 1;
        er.commodity = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.commodity = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp =
          /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;

        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.commodity = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.commodity = "";
        }
      }
    }

    if (e.target.name === "cbpp") {
      const isBulk = formData.ocean_type === "Bulk";
      const isRequired = !isBulk;
      let no = e.target.value;
      let noReg =
        /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;
      if (isRequired && no === "") {
        flag = 1;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 150) {
          flag = 1;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.cbpp = "";
          }
        }
      }
    }

    if (e.target.name === "total_weight") {
      let no = e.target.value;
      let noReg =
        /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;
      if (e.target.value !== "" && no.length > 0) {
        if (no.length > 80) {
          flag = 1;
          er.total_weight = errorMessages.MAX_LENGTH_80_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.total_weight = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.total_weight = "";
          }
        }
      }
    }

    if (e.target.name === "term") {
      if (e.target.value === "") {
        flag = 1;
        er.term = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.term = "";
      }
    }

    if (e.target.name === "pickup_address") {
      let pickup_address_len = e.target.value;
      if (
        !isEmpty(formData.term) &&
        showPickupAddress.includes(formData.term)
      ) {
        if (e.target.value === "") {
          flag = 1;
          er.pickup_address = errorMessages.FIELD_REQUIRED;
        } else if (pickup_address_len.length > 255) {
          flag = 1;
          er.pickup_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          flag = 0;
          er.pickup_address = "";
        }
      }
    }

    if (e.target.name === "delivery_address") {
      let delivery_address_len = e.target.value;
      if (
        !isEmpty(formData.term) &&
        showDeliveryAddress.includes(formData.term)
      ) {
        if (e.target.value === "") {
          flag = 1;
          er.delivery_address = errorMessages.FIELD_REQUIRED;
        } else if (delivery_address_len.length > 255) {
          flag = 1;
          er.delivery_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          flag = 0;
          er.delivery_address = "";
        }
      }
    }

    if (e.target.name === "emailIds") {
      if (e.target.value === "") {
        flag = 1;
        er.emailIds = errorMessages.FIELD_REQUIRED;
      } else {
        let fEmails = e.target.value;
        fEmails = fEmails.split(",");
        if (fEmails.length > 0) {
          for (let fe of fEmails) {
            const currentEmail = fe.split("@")[1];
            const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const check = regExp.test(fe);
            if (check === false) {
              flag = 1;
              er.emailIds = errorMessages.IN_VALID_FIELD_FORMAT;
            } else if (invalidEmails.includes(currentEmail)) {
              flag = 1;
              er.emailIds = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              flag = 0;
              er.emailIds = "";
            }
          }
        }
      }
    }

    if (e.target.name === "port_of_origin") {
      let error = validatePortInput(e.target.value);
      if (error === null) {
        let port_of_origin_len = e.target.value;
        if ((e.target.value === "" || e.target.value === null) && formData.freight_type != "Road") {
          flag = 1;
          er.port_of_origin = errorMessages.FIELD_REQUIRED;
        } else if (port_of_origin_len.length > 50) {
          flag = 1;
          er.port_of_origin = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          flag = 0;
          er.port_of_origin = "";
        }
      } else {
        er.port_of_origin = error;
        flag = 0;
      }
    }

    if (e.target.name === "port_of_destination") {
      let error = validatePortInput(e.target.value);
      if (error === null) {
        let port_of_destination_len = e.target.value;
        if ((e.target.value === "" || e.target.value === null) && formData.freight_type != "Road") {
          flag = 1;
          er.port_of_destination = errorMessages.FIELD_REQUIRED;
        } else if (port_of_destination_len.length > 50) {
          flag = 1;
          er.port_of_destination = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          flag = 0;
          er.port_of_destination = "";
        }
      } else {
        er.port_of_destination = error;
        flag = 0;
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      return true;
    }
  };

  const validateAirFreight = async (er, isValid) => {
    if (!er) er = {};
    er.lwh_qty_packaging = [];

    if (Array.isArray(formData.lwh_qty_packaging)) {
      formData.lwh_qty_packaging.forEach((item, index) => {
        const rowError = {};

        // L/W/H Validation
        let lwhVal = item.lwh ? String(item.lwh).trim() : "";
        if (lwhVal === "") {
          isValid = false;
          rowError.lwh = errorMessages.FIELD_REQUIRED;
        } else if (lwhVal.length > 50) {
          isValid = false;
          rowError.lwh = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else if (
          regExpressions.inquiry.lwh &&
          !regExpressions.inquiry.lwh.test(lwhVal)
        ) {
          isValid = false;
          rowError.lwh = errorMessages.IN_VALID_FIELD_FORMAT;
        }

        // Quantity Validation
        let qtyVal = item.no_qty ? String(item.no_qty).trim() : "";
        if (qtyVal === "") {
          isValid = false;
          rowError.no_qty = errorMessages.FIELD_REQUIRED;
        } else if (
          regExpressions.inquiry.no_of_containers &&
          !regExpressions.inquiry.no_of_containers.test(qtyVal)
        ) {
          isValid = false;
          rowError.no_qty = errorMessages.IN_VALID_FIELD_FORMAT;
        }

        // Packaging Type Dropdown Validation
        if (!item.cbpp || String(item.cbpp).trim() === "") {
          isValid = false;
          rowError.cbpp = errorMessages.FIELD_REQUIRED;
        }

        er.lwh_qty_packaging[index] = rowError;
      });
    }

    return { er, isValid };
  };

  const validateRoadFreight = (er, isValid) => {
    if (!er) er = {};

    if (formData.no_of_containers == "") {
      isValid = false;
      er.no_of_containers = errorMessages.FIELD_REQUIRED;
    } else if (
      regExpressions.inquiry.no_of_containers &&
      !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
    ) {
      isValid = false;
      er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
    }

    let no2 = formData.cbpp;
    let noReg2 = regExpressions.inquiry.cbpp;
    if (no2 === "") {
      isValid = false;
      er.cbpp = errorMessages.FIELD_REQUIRED;
    } else if (no2 !== "" && no2.length > 0) {
      if (no2.length > 150) {
        isValid = false;
        er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const check = noReg2.test(no2);
        if (check === false) {
          isValid = false;
          er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.cbpp = "";
        }
      }
    } else {
      er.cbpp = "";
    }

    return { er, isValid };
  };

  const validateSeaFreight = (er, isValid) => {
    if (!er) er = {};

    if (formData.ocean_type == "LCL") {
      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "FCL") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "Ro-Ro") {
      if (
        formData.no_of_containers != "" &&
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.ocean_type == "Project_Cargo") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (
      formData.ocean_type == "DAG_GOODS" ||
      formData.ocean_type == "LCL_FCL"
    ) {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    return { er, isValid };
  };

  const validateDAPFreight = (er, isValid) => {
    if (!er) er = {};
    if (formData.ocean_type == "LCL") {
      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "FCL") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "Ro-Ro") {
      if (
        formData.no_of_containers != "" &&
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.ocean_type == "Project_Cargo") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.ocean_type == "DAG_GOODS") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    return { er, isValid };
  };

  const validation = async () => {
    let er = { ...errors };
    let isValid = true;
    const isBulk = formData.ocean_type === "Bulk";
    const isFCL = formData.ocean_type === "FCL";

    if (!formData.company_name || formData.company_name === "") {
      isValid = false;
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.company_name.length > 150) {
      isValid = false;
      er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExp = regExpressions.company_name;
      const check = regExp.test(formData.company_name);
      if (check === false) {
        isValid = false;
        er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.company_name = "";
      }
    }

    if (formData.contact_person === "") {
      isValid = false;
      er.contact_person = errorMessages.FIELD_REQUIRED;
    } else if (formData.contact_person.length > 50) {
      isValid = false;
      er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
    } else {
      const regExp = regExpressions.name;
      const check = regExp.test(formData.contact_person);
      if (check === false) {
        isValid = false;
        er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.contact_person = "";
      }
    }

    if (formData.email === "") {
      isValid = false;
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      isValid = false;
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      // const currentEmail = formData.email.split("@")[1];
      // const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // const check = regExp.test(formData.email);
      // if (check === false) {
      //     isValid = false;
      //     er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      // } else if (invalidEmails.includes(currentEmail)) {
      //     isValid = false;
      //     er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      // } else {
      er.email = "";
      // }
    }

    if (phoneValue) {
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, "");
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, "");
      if (
        !phoneValue ||
        (!isValidPhoneNumber(phoneValue) && numberWithoutCountryCode.length > 0)
      ) {
        isValid = false;
        er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      }
    }

    if (formData.freight_type != "Road") {
      if (formData.country_from === "") {
        isValid = false;
        er.country_from = errorMessages.FIELD_REQUIRED;
      } else {
        er.country_from = "";
      }

      if (formData.port_of_origin === "") {
        isValid = false;
        er.port_of_origin = errorMessages.FIELD_REQUIRED;
      } else if (formData.port_of_origin.length > 50) {
        isValid = false;
        er.port_of_origin = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        er.port_of_origin = "";
      }

      if (formData.freight_type != "DAP") {
        if (formData.country_to === "") {
          isValid = false;
          er.country_to = errorMessages.FIELD_REQUIRED;
        } else {
          er.country_to = "";
        }

        if (formData.port_of_destination === "") {
          isValid = false;
          er.port_of_destination = errorMessages.FIELD_REQUIRED;
        } else if (formData.port_of_destination.length > 50) {
          isValid = false;
          er.port_of_destination = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          er.port_of_destination = "";
        }
      }
    }

    if (formData.freight_type != "" && formData.freight_type != "Air") {
      if (formData.ocean_type === "" || formData.ocean_type === null) {
        isValid = false;
        er.ocean_type = errorMessages.FIELD_REQUIRED;
      } else {
        er.ocean_type = "";
      }
    }

    if (formData.freight_type === "") {
      isValid = false;
      er.freight_type = errorMessages.FIELD_REQUIRED;
    } else {
      er.freight_type = "";
    }

    if (!formData.commodity || formData.commodity === "") {
      isValid = false;
      er.commodity = errorMessages.FIELD_REQUIRED;
    } else if (formData.commodity.length > 150) {
      isValid = false;
      er.commodity = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExp =
        /^(?=.*[a-zA-Z])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;

      const check = regExp.test(formData.commodity);
      if (check === false) {
        isValid = false;
        er.commodity = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.commodity = "";
      }
    }

    let no3 = formData.total_weight;
    let noReg3 =
      /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9\s\-\'.\(\)&]+(\([a-zA-Z0-9\s\-\'.\&]*\))?[a-zA-Z0-9\s\-\'.\(\)&]*$/;
    if (no3 !== "" && no3.length > 0) {
      if (no3.length > 80) {
        isValid = false;
        er.total_weight = errorMessages.MAX_LENGTH_80_EXCEEDED;
      } else {
        const check = noReg3.test(no3);
        if (check === false) {
          isValid = false;
          er.total_weight = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.total_weight = "";
        }
      }
    }

    if (formData.freight_type != "Road" && formData.freight_type != "DAP" ) {
      if (formData.term === "") {
      isValid = false;
      er.term = errorMessages.FIELD_REQUIRED;
    } else {
      er.term = "";
    }
  }

    if (!isEmpty(formData.term) && showPickupAddress.includes(formData.term)) {
      let pickup_address_len = formData.pickup_address;
      if (formData.pickup_address === "") {
        isValid = false;
        er.pickup_address = errorMessages.FIELD_REQUIRED;
      } else if (pickup_address_len.length > 255) {
        isValid = false;
        er.pickup_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        er.pickup_address = "";
      }
    }

    if (
      (!isEmpty(formData.term) &&
        showDeliveryAddress.includes(formData.term)) ||
      formData.freight_type === "DAP"
    ) {
      let delivery_address_len = formData.delivery_address;
      if (formData.delivery_address === "") {
        isValid = false;
        er.delivery_address = errorMessages.FIELD_REQUIRED;
      } else if (delivery_address_len.length > 255) {
        isValid = false;
        er.delivery_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        er.delivery_address = "";
      }
    }

    if (formData.freight_type === "" || formData.freight_type === "Air") {
      let res = await validateAirFreight(er, isValid);
      console.log("res ======================== ", res);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "Road") {
      let res = await validateRoadFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "DAP") {
      let res = await validateDAPFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "Ocean") {
      let res = await validateSeaFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    if (user && isDemoUser) {
      if (formData.emailIds === "") {
        isValid = false;
        er.emailIds = errorMessages.FIELD_REQUIRED;
      } else {
        let fEmails = formData.emailIds.split(",");
        if (fEmails.length > 0) {
          for (let fe of fEmails) {
            let fe1 = trim(fe);
            const currentEmail = fe1.split("@")[1];
            const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const check = regExp.test(fe1);
            if (check === false) {
              isValid = false;
              er.emailIds = errorMessages.IN_VALID_FIELD_FORMAT;
            } else if (invalidEmails.includes(currentEmail)) {
              isValid = false;
              er.emailIds = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              er.emailIds = "";
            }
          }
        }
      }
    }

    if ((isSuperAdmin || isInqUser) && inqType != "REQ_MOCK_INQ") {
      if (!isChecked) {
        isValid = false;
        er.assignInq = errorMessages.FIELD_REQUIRED;
        // er.assignCountry = errorMessages.FIELD_REQUIRED;
        // er.assignCompany = errorMessages.FIELD_REQUIRED;
        er.countryCompany = [];
      } else if (isChecked) {
        er.countryCompany = [];

        map(assignCountryCompany, (item, key) => {
          if (!er.countryCompany[key]) {
            er.countryCompany[key] = {};
          }

          if (item.country_id <= 0) {
            isValid = false;
            er.countryCompany[key].country = errorMessages.FIELD_REQUIRED;
          } else {
            er.countryCompany[key].country = "";
          }

          if (item.member_id <= 0) {
            isValid = false;
            er.countryCompany[key].company = errorMessages.FIELD_REQUIRED;
          } else {
            er.countryCompany[key].company = "";
          }
        });
      } else {
        // er.assignCountry = "";
        // er.assignCompany = "";
        er.countryCompany = [];
      }
    }

    if ((isSuperAdmin || isInqUser) && inqType === "REQ_MOCK_INQ") {
      if (!isChecked) {
        er.assignInq = "";

        // Validate assignCountry
        if (formData.assignCountry === null || formData.assignCountry === "") {
          isValid = false;
          er.assignCountry = errorMessages.FIELD_REQUIRED;
        } else {
          er.assignCountry = "";
        }

        // Validate assignCompany
        if (formData.assignCompany === null || formData.assignCompany === "") {
          isValid = false;
          er.assignCompany = errorMessages.FIELD_REQUIRED;
        } else {
          er.assignCompany = "";
        }
      } else {
        // When checkbox IS checked
        er.assignInq = "";
        er.assignCountry = "";
        er.assignCompany = "";
      }
    }

    setErrors(er);
    if (!isValid) {
      return false;
    }
    return true;
  };
  const fetchCountryPorts = async (countryId, type) => {
    if (type == "countryFrom") {
      setOriginLoader(true);
    } else if (type == "countryTo") {
      setDestinationLoader(true);
    }
    await axios
      .get(API_URL + "/country-port-list/" + countryId)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((port) => ({
              value: port.id,
              label: port.name,
            }));
            if (type == "countryFrom") {
              setPortOfOriginList(options);
            } else if (type == "countryTo") {
              setPortOfDestinationList(options);
            }
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
    if (type == "countryFrom") {
      setOriginLoader(false);
    } else if (type == "countryTo") {
      setDestinationLoader(false);
    }
  };

  const fetchAllPorts = async (offset, limit, searchTxt = "", type) => {
    if (type == "portOfOrigin") {
      setOriginLoader(true);
    } else if (type == "portOfDestination") {
      setDestinationLoader(true);
    }
    let searchQuery = "";
    if (!isEmpty(searchTxt)) {
      searchQuery = "/" + encode(searchTxt);
    }
    await axios
      .get(API_URL + "/all-port-list/" + offset + "/" + limit + searchQuery)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((port) => ({
              value: port.id,
              label: port.name,
            }));
            if (type == "portOfOrigin") {
              setPortOfDestinationList(portOfDestinationList);
              setPortOfOriginList(options);
            } else if (type == "portOfDestination") {
              setPortOfOriginList(portOfOriginList);
              setPortOfDestinationList(options);
            }
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
    if (type == "portOfOrigin") {
      setOriginLoader(false);
    } else if (type == "portOfDestination") {
      setDestinationLoader(false);
    }
  };

  const handlePortOfOriginChange = async (val) => {
    if (val != null) {
      const portOfOrigin = val.label;
      setSelectedPortOfOrigin(val);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          port_of_origin: portOfOrigin,
          isNewValOrigin: val.__isNew__ ? val.__isNew__ : false,
        };
      });
    }
  };

  const handlePortOfDestinationChange = async (val) => {
    if (val != null) {
      const portOfDestination = val.label;
      setSelectedPortOfDestination(val);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          port_of_destination: portOfDestination,
          isNewValDestination: val.__isNew__ ? val.__isNew__ : false,
        };
      });
    }
  };

  const handleInputChange = (val) => {
    if (val !== "") {
      if (val.length >= 3) {
        const type = "portOfOrigin";
        setPortOfOriginList([]);
        fetchAllPorts(0, 10, val, type);
      }
    } else {
      if (
        selectedFreightType?.value === "Ocean" ||
        selectedFreightType?.value == null
      ) {
        const countryId = selectedCountryFrom?.country_id || "";
        if (countryId) {
          setPortOfOriginList([]);
          fetchCountryPorts(countryId, "countryFrom");
        }
      }
    }
  };

  const handleDestinationInputChange = (val) => {
    if (val !== "") {
      if (val.length >= 3) {
        const type = "portOfDestination";
        setPortOfDestinationList([]);
        fetchAllPorts(0, 10, val, type);
      }
    } else {
      if (
        selectedFreightType?.value === "Ocean" ||
        selectedFreightType?.value == null
      ) {
        const countryId = selectedCountryTo?.country_id || "";
        if (countryId) {
          setPortOfDestinationList([]);
          fetchCountryPorts(countryId, "countryTo");
        }
      }
    }
  };
  const validatePortInput = (inputValue) => {
    if (inputValue === "") return null;

    const validPortRegex = regExp.port_name;
    let error = "";
    if (!validPortRegex.test(inputValue)) {
      error = errorMessages.IN_VALID_FIELD_FORMAT;
    }
    return error || null;
  };

  const validatePortDestinationInput = (inputValue) => {
    if (inputValue === "") return null;

    const validPortRegex = regExp.port_name;
    let error = "";
    if (!validPortRegex.test(inputValue)) {
      error = errorMessages.IN_VALID_FIELD_FORMAT;
    }
    return error || null;
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    props.setMediumModalShow(false);
  };

  const handleCheckboxChange = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    if (inqType === "REQ_MOCK_INQ") {
      setAssignCompany(null);
      setAssignCountry(null);
      setCompanyList([]);
      setFormData((prev) => ({
        ...prev,
        assignCountry: null,
        assignCompany: null,
      }));
      setErrors((prev) => ({
        ...prev,
        assignCountry: "",
        assignCompany: "",
      }));
    }
  };

  const handleAssignCountryChange = async (val) => {
    // props.showLoading();
    let inqPage =
      props.inq_type !== undefined && props.inq_type !== null
        ? props.inq_type
        : null;
    console.log("inqPage ----------", inqPage);

    setCompanyList([]);
    setAssignCompany(null);
    //console.log("Val =========== ", val);
    let countryObj = {
      label: val.label,
      value: val.country_id,
    };
    setAssignCountry(countryObj);
    // set req_mock inq
    setFormData((prev) => ({
      ...prev,
      assignCountry: val.country_id,
      assignCompany: null,
    }));

    setErrors((prev) => ({
      ...prev,
      assignCountry: "",
      assignCompany: "",
    }));
    let payload = {
      country: val.value,
      inquiry_for: "LOG_PTR",
      search: "NO",
      inqPage: inqPage,
    };
    setMemberOptLoader(true);
    await props
      .getCompaniesByCountry(payload)
      .then((data) => {
        if (!isEmpty(data)) {
          const options = data.map((ct) => ({
            value: ct.id,
            label: ct.company_list_name,
            email: ct.email,
          }));
          setCompanyList(options);
        }
        // props.hideLoading();
        setMemberOptLoader(false);
      })
      .catch((err) => {
        console.log("Error >>>>>>>>>>", err);
        // props.hideLoading();
        setMemberOptLoader(false);
      });
  };

  const handleAssignCompanyChange = (val) => {
    setAssignCompany(val);
    setFormData((prev) => ({
      ...prev,
      assignCompany: val.value,
    }));

    setErrors((prev) => ({
      ...prev,
      assignCompany: "",
    }));
  };

  const handleAssignCompanyInputChange = (newValue) => {
    let inqPage =
      props.inq_type !== undefined && props.inq_type !== null
        ? props.inq_type
        : null;
    console.log("inqPage ----------", inqPage);
    //console.log("AssignCountry =========== ", assignCountry);
    if (newValue !== "" && assignCountry) {
      let inquiry_for = "LOG_PTR";
      const headers = setAuthHeaders();
      if (newValue.length >= 3) {
        setMemberOptLoader(true);
        setCompanyList([]);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: assignCountry.value,
              inquiry_for: inquiry_for,
              search: "YES",
              inqPage: inqPage,
            },
            { headers },
          )
          .then((response) => {
            if (response.status === 200) {
              if (response.data.status === true) {
                if (!isEmpty(response.data.data)) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label: ct.company_list_name,
                    email: ct.email,
                  }));
                  setCompanyList(options);
                  setMemberOptLoader(false);
                } else {
                  axiosHttp
                    .post(
                      API_URL + "/get-company",
                      {
                        country: assignCountry.label,
                        inquiry_for: inquiry_for,
                        search: "NO",
                        inqPage: inqPage,
                      },
                      {
                        headers,
                      },
                    )
                    .then((response) => {
                      if (response.status === 200) {
                        setMemberOptLoader(false);
                        if (response.data.status === true) {
                          const options = response.data.data.map((ct) => ({
                            value: ct.id,
                            label: ct.company_list_name,
                            email: ct.email,
                          }));
                          setCompanyList(options);
                        }
                      }
                    })
                    .catch((err) => {
                      console.log("Error ============= ", err);
                    });
                }
              }
            }
          });
      }
      // else {
      // setCompanyList([]);
      // setSelectedCompany(null);
      // setCompanyAndCountry(selectedInquiry);
      // }
    } else {
      //getCompanyListBasedOnCountry(formData.country_assign);
    }

    // if(isEmpty(selectedCompany)){
    //   setCompanyList([]);
    // }
  };

  const customFilter = (option, searchTxt) => {
    if (option.data.email.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else if (
      option.data.label.toLowerCase().includes(searchTxt.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    // if (isSuperAdmin && inqType != 'REQ_MOCK_INQ') {
    //     setFormData(prev => ({
    //         ...prev,
    //         assignCountry: (isChecked === true && assignCountry) ? assignCountry.value : null,
    //         assignCompany: (isChecked === true && assignCompany) ? assignCompany.value : null
    //     }));
    // }
  }, [isChecked, assignCountry, assignCompany, isSuperAdmin, inqType]);

  const fetchCountries = async () => {
    await props
      .getCountryList()
      .then((data) => {
        const options = data.map((country) => ({
          value: country.name,
          label: country.name,
          countryCode: country.iso2,
          country_id: country.id,
        }));
        setCountryList(options);
      })
      .catch((err) => {
        console.log("Error >>>> ", err);
      });
  };

  const handleAddClick = () => {
    setAssignCountryCompany((prevalue) => {
      return [
        ...prevalue,
        {
          country_id: 0,
          member_id: 0,
          country: null,
          company: null,
          companyList: [],
        },
      ];
    });
  };

  const handleRemoveClick = (e, index) => {
    let cntcompObj = [...assignCountryCompany];
    delete cntcompObj[index];
    cntcompObj = filter(cntcompObj);

    if (isEmpty(cntcompObj)) {
      cntcompObj[0] = {
        country_id: 0,
        member_id: 0,
        country: null,
        company: null,
        companyList: [],
      };
    }

    setAssignCountryCompany(cntcompObj);

    let er = { ...errors };
    let companyError = er.countryCompany;
    if (companyError) {
      delete companyError[index];
      companyError = filter(companyError);
      er.countryCompany = companyError;
      setErrors(er);
    }
  };

  const handleAssignCountryChangeByIndex = async (val, indx) => {
    let inqPage =
      props.inq_type !== undefined && props.inq_type !== null
        ? props.inq_type
        : null;

    let cntcompObj = [...assignCountryCompany];
    cntcompObj[indx]["country_id"] = val.country_id;

    let countryObj = {
      label: val.label,
      value: val.country_id,
    };
    cntcompObj[indx]["country"] = countryObj;
    cntcompObj[indx]["companyList"] = [];

    let payload = {
      country: val.value,
      inquiry_for: "LOG_PTR",
      search: "NO",
      inqPage: inqPage,
    };
    setMemberOptLoader(true);
    await props
      .getCompaniesByCountry(payload)
      .then((data) => {
        if (!isEmpty(data)) {
          const options = data.map((ct) => ({
            value: ct.id,
            label: ct.company_list_name,
            email: ct.email,
          }));
          // setCompanyList(options);
          cntcompObj[indx]["companyList"] = options;
        }
        // props.hideLoading();
        setMemberOptLoader(false);
      })
      .catch((err) => {
        console.log("Error :", err);
        props.hideLoading();
      });

    setAssignCountryCompany(cntcompObj);

    let newcntcompObj = cloneDeep(cntcompObj);

    delete newcntcompObj[indx]["companyList"];
    delete newcntcompObj[indx]["country"];
    delete newcntcompObj[indx]["company"];

    newcntcompObj = filter(newcntcompObj);

    setFormData((prev) => {
      return {
        ...prev,
        country_obj: newcntcompObj,
      };
    });
  };

  const handleAssignCompanyChangeByIndex = (val, indx) => {
    //console.log("val=================", val);
    let cntcompObj = [...assignCountryCompany];
    cntcompObj[indx]["member_id"] = val.value;
    let companyObj = {
      label: val.label,
      value: val.value,
    };
    cntcompObj[indx]["company"] = companyObj;
    setAssignCountryCompany(cntcompObj);

    let newcntcompObj = cloneDeep(cntcompObj);

    delete newcntcompObj[indx]["companyList"];
    delete newcntcompObj[indx]["country"];
    delete newcntcompObj[indx]["company"];

    newcntcompObj = filter(newcntcompObj);

    setFormData((prev) => {
      return {
        ...prev,
        country_obj: newcntcompObj,
      };
    });
  };

  const handleAssignCompanyInputChangeByIndex = (newValue, indx) => {
    let inqPage =
      props.inq_type !== undefined && props.inq_type !== null
        ? props.inq_type
        : null;

    //console.log("AssignCountry =========== ", assignCountry);
    if (
      newValue !== "" &&
      assignCountryCompany &&
      assignCountryCompany[indx] &&
      assignCountryCompany[indx].country_id
    ) {
      console.log(
        "inqPage ----------",
        inqPage,
        " --------------- ",
        newValue,
        " ----------------------------- ",
        assignCountryCompany,
        " ---- country-id ---- ",
        assignCountryCompany[indx].country_id,
      );
      let inquiry_for = "LOG_PTR";
      const headers = setAuthHeaders();
      if (newValue.length >= 3) {
        setMemberOptLoader(true);
        setCompanyList([]);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: assignCountryCompany[indx].country_id,
              inquiry_for: inquiry_for,
              search: "YES",
              inqPage: inqPage,
            },
            { headers },
          )
          .then((response) => {
            if (response.status === 200) {
              if (response.data.status === true) {
                let tmpassignCountryCompany = [...assignCountryCompany];
                if (!isEmpty(response.data.data)) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label: ct.company_list_name,
                    email: ct.email,
                  }));

                  tmpassignCountryCompany[indx]["companyList"] = options;
                  // setCompanyList(options);
                  setAssignCountryCompany(tmpassignCountryCompany);
                  setMemberOptLoader(false);
                } else {
                  axiosHttp
                    .post(
                      API_URL + "/get-company",
                      {
                        country:
                          tmpassignCountryCompany[indx]["country"]["label"],
                        inquiry_for: inquiry_for,
                        search: "NO",
                        inqPage: inqPage,
                      },
                      {
                        headers,
                      },
                    )
                    .then((response) => {
                      if (response.status === 200) {
                        setMemberOptLoader(false);
                        if (response.data.status === true) {
                          const options = response.data.data.map((ct) => ({
                            value: ct.id,
                            label: ct.company_list_name,
                            email: ct.email,
                          }));
                          // setCompanyList(options);
                          tmpassignCountryCompany[indx]["companyList"] =
                            options;
                          setAssignCountryCompany(tmpassignCountryCompany);
                        }
                      }
                    })
                    .catch((err) => {
                      console.log("Error ============= ", err);
                    });
                }
              }
            }
          });
      }
      // else {
      // setCompanyList([]);
      // setSelectedCompany(null);
      // setCompanyAndCountry(selectedInquiry);
      // }
    } else {
      //getCompanyListBasedOnCountry(formData.country_assign);
    }
  };

  const [fileInputKey, setFileInputKey] = useState({
    FILE1: 0,
    FILE2: 0,
    FILE3: 0,
  });

  const activeSlugRef = useRef(null);
  const fileChangedRef = useRef(false);

  const handleFileClick = (slug) => {
    activeSlugRef.current = slug;
    fileChangedRef.current = false;
  };

  const handleChange2 = (e) => {
    const { name, files } = e.target;

    fileChangedRef.current = true;

    if (!files || files.length === 0) {
      const slug = activeSlugRef.current;
      activeSlugRef.current = null;

      if (!slug) return; // nothing was tracked, nothing to clear

      const fieldName = `attechment#@${slug}`;

      setFile2((prev) => {
        if (prev[fieldName]?.path?.startsWith("blob:")) {
          URL.revokeObjectURL(prev[fieldName].path);
        }
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });

      setFormData((prev) => {
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });

      setVErrors2((prev) => {
        const updated = { ...prev };
        delete updated[fieldName];
        return updated;
      });

      setFileInputKey((prev) => ({ ...prev, [slug]: prev[slug] + 1 }));
      return;
    }

    activeSlugRef.current = null;

    const file = files[0];
    let error = "";

    if (!ALLOWED_TYPES.includes(file.type)) {
      error =
        "The file must be of type: jpg, jpeg, png, webp, pdf, doc, excel or csv.";
    } else if (file.size > MAX_FILE_SIZE) {
      error = "The file must be less than or equal to 2 MB";
    }

    if (error) {
      setVErrors2((prev) => ({ ...prev, [name]: error }));
      return;
    }

    setVErrors2((prev) => {
      const updated = { ...prev };
      delete updated[name];
      return updated;
    });

    const fileExtension = file.name.split(".").pop().toLowerCase();
    const category = EXT_CATEGORY[fileExtension] ?? "";

    setFile2((prev) => {
      if (prev[name]?.path?.startsWith("blob:")) {
        URL.revokeObjectURL(prev[name].path);
      }
      return {
        ...prev,
        [name]: { path: URL.createObjectURL(file), fileType: category },
      };
    });

    setFormData((prev) => ({ ...prev, [name]: file }));
  };

  const handleRemoveFile = (slug) => {
    const fieldName = `attechment#@${slug}`;

    setFile2((prev) => {
      if (prev[fieldName]?.path?.startsWith("blob:")) {
        URL.revokeObjectURL(prev[fieldName].path);
      }
      const updated = { ...prev };
      delete updated[fieldName];
      return updated;
    });

    // remove the file from the form payload
    setFormData((prev) => {
      const updated = { ...prev };
      delete updated[fieldName];
      return updated;
    });

    // clear any validation error tied to this slot
    setVErrors2((prev) => {
      const updated = { ...prev };
      delete updated[fieldName];
      return updated;
    });

    // force the file input to remount so the browser-shown filename actually clears
    setFileInputKey((prev) => ({ ...prev, [slug]: prev[slug] + 1 }));

    activeSlugRef.current = null;
    fileChangedRef.current = false;
  };

  const validateOnSubmit = () => {
    const newErrors = {};
    let isValid = true;

    const showFileSection =
      (isSuperAdmin || isInqUser) && inqType !== "REQ_MOCK_INQ";

    if (showFileSection) {
      FILE_SLOTS.forEach((slug) => {
        const fieldName = `attechment#@${slug}`;
        const fileValue = formData[fieldName];

        if (verrors2[fieldName]) {
          newErrors[fieldName] = verrors2[fieldName];
          isValid = false;
          return;
        }

        // Normal check for files that passed handleChange2
        if (fileValue) {
          if (!ALLOWED_TYPES.includes(fileValue.type)) {
            newErrors[fieldName] =
              "The file must be of type: jpg, jpeg, png, webp, pdf, doc, excel or csv.";
            isValid = false;
          } else if (fileValue.size > MAX_FILE_SIZE) {
            newErrors[fieldName] =
              "The file must be less than or equal to 2 MB";
            isValid = false;
          }
        }
      });
    }

    setVErrors2((prev) => ({ ...prev, ...newErrors }));
    return isValid;
  };

  const handleLogisticInquirySubmit = async (e) => {
    e.preventDefault();

    const basicValid = await validation();
    const attachmentValid = await validateOnSubmit();

    const hasFileErrors = Object.keys(verrors2).length > 0;

    if (!basicValid || !attachmentValid || hasFileErrors) return;

    const authHeaders = setAuthHeaders();
    const headers = {
      ...authHeaders.headers,
      "Content-Type": "multipart/form-data",
    };

    const formPayload = new FormData();

    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (value === null || value === undefined) return;

      if (value instanceof File) {
        formPayload.append(key, value);
      } else if (typeof value === "object") {
        formPayload.append(key, JSON.stringify(value));
      } else {
        formPayload.append(key, value);
      }
    });
    setisButtonDisabled(true);
    await props.showLoading();

    try {
      const response = await axiosHttp.post(
        API_URL + "/post-inquiry",
        formPayload,
        { headers, timeout: 60000 },
      );

      props.hideLoading();

      if (response?.status === 200 && response?.data?.status === true) {
        props.setMediumModalShow(false);

        setTimeout(() => {
          if (props.fromPage === "list") {
            props.getData(
              props.limit,
              props.current_page,
              props.searchFilterObj,
            );
          }
          if (props.fromPage === "MOCK_LIST") {
            props.getData(0, 10, 1, "id", "DESC", "");
          }
          setPortOfOriginList([]);
          setSelectedPortOfOrigin(null);
          setPortOfDestinationList([]);
          setSelectedPortOfDestination(null);
          setFormData(initialState);
          setErrors({});
          setphoneValue("");
          setSelectedCountryFrom(null);
          setSelectedCountryTo(null);
          setSelectedFreightType(null);
          setSelectedOceanType(null);
          setSelectedTerm(null);
          setisButtonDisabled(false);
          setFile2({});
          setFileInputKey({ FILE1: 0, FILE2: 0, FILE3: 0 });
          FILE_SLOTS.forEach((slug) => {
            if (fileRefs[slug]?.current) {
              fileRefs[slug].current.value = "";
            }
          });

          activeSlugRef.current = null;
          fileChangedRef.current = false;
          showSuccessMessage("Inquiry Posted Successfully!");
        }, 1000);
      } else {
        setisButtonDisabled(false);
        setErrors([]);
        const errors = {};
        if (response.data.errors.company_name) {
          errors.company_name = response.data.errors.company_name;
        }
        if (response.data.errors.contact_person) {
          errors.contact_person = response.data.errors.contact_person;
        }
        if (response.data.errors.email) {
          errors.email = response.data.errors.email;
        }
        if (response.data.errors.cbpp) {
          errors.cbpp = response.data.errors.cbpp;
        }
        if (response.data.errors.country_from) {
          errors.country_from = response.data.errors.country_from;
        }
        if (response.data.errors.country_to) {
          errors.country_to = response.data.errors.country_to;
        }

        if (response.data.errors.freight_type) {
          errors.freight_type = response.data.errors.freight_type;
        }
        if (response.data.errors.port_of_destination) {
          errors.port_of_destination = response.data.errors.port_of_destination;
        }
        if (response.data.errors.port_of_origin) {
          errors.port_of_origin = response.data.errors.port_of_origin;
        }
        if (response.data.errors.commodity) {
          errors.commodity = response.data.errors.commodity;
        }
        if (response.data.errors.term) {
          errors.term = response.data.errors.term;
        }
        if (response.data.errors.pickup_address) {
          errors.pickup_address = errorMessages.FIELD_REQUIRED;
        }
        if (response.data.errors.delivery_address) {
          errors.delivery_address = errorMessages.FIELD_REQUIRED;
        }

        if (response.data.errors.lwh) {
          errors.lwh = response.data.errors.lwh;
        }

        if (response.data.errors.ocean_type) {
          errors.ocean_type = response.data.errors.ocean_type;
        }
        if (response.data.errors.no_of_containers) {
          errors.no_of_containers = response.data.errors.no_of_containers;
        }

        setErrors(errors);
        return Object.keys(errors).length > 0;
      }
    } catch (err) {
      props.hideLoading();
      setisButtonDisabled(false);
      console.error("Error:", err);
      showErrorMessage("Something Went Wrong!");
    }
  };

  const handleFieldAddClick = () => {
    const blankRow = { lwh: " ", no_qty: " ", cbpp: " " };
    setFormData((prevData) => {
      return {
        ...prevData,
        lwh_qty_packaging: [
          ...(prevData.lwh_qty_packaging || []),
          { ...blankRow },
        ],
      };
    });
  };

  const handleFieldRemoveClick = (indx) => {
    setFormData((prevData) => {
      return {
        ...prevData,
        lwh_qty_packaging: filter(
          prevData.lwh_qty_packaging,
          (_, index) => index != indx,
        ),
      };
    });
  };

  const handleLQPChange = (e, field_name, indx) => {
    console.log("handleLQPChange =======================", field_name);
    const { value } = e.target;

    setFormData((prevData) => {
      const updatedRows = [...(prevData.lwh_qty_packaging || [])];

      updatedRows[indx] = {
        ...updatedRows[indx],
        [field_name]: value,
      };

      return {
        ...prevData,
        lwh_qty_packaging: updatedRows,
      };
    });
  };

  const handleLQPcbppChange = (selectedOption, field_name, indx) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prevData) => {
      // Deep clone state safely
      const nextData = cloneDeep(prevData);

      if (nextData.lwh_qty_packaging && nextData.lwh_qty_packaging[indx]) {
        nextData.lwh_qty_packaging[indx][field_name] = selectedValue;
      }

      return nextData;
    });
  };

  const handleLQPFocusOut = (indx, field_name) => {
    const targetRow = formData.lwh_qty_packaging[indx];
    let errorMsg = "";

    if (field_name === "lwh") {
      if(!targetRow.lwh || !targetRow.lwh.trim()) {
        errorMsg = errorMessages.FIELD_REQUIRED;
      } else if(size(targetRow.lwh) > 150) {
        errorMsg = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else if(regExpressions.inquiry.lwh && !regExpressions.inquiry.lwh.test(targetRow.lwh)) {
        errorMsg = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (field_name === "no_qty") {
      if (!targetRow.no_qty || !targetRow.no_qty.trim()) {
        errorMsg = errorMessages.FIELD_REQUIRED;
      } else if (regExpressions.inquiry.no_of_containers && !regExpressions.inquiry.no_of_containers.test(targetRow.no_qty)) {
         errorMsg = errorMessages.IN_VALID_FIELD_FORMAT;
      }
      // else if (isNaN(targetRow.no_qty)) errorMsg = "Must be a number";
    }

    if (field_name === "cbpp" && !targetRow.cbpp) {
      errorMsg = errorMessages.FIELD_REQUIRED;
    }

    setErrors((prevErrors) => {
      const nextErrors = cloneDeep(prevErrors);

      if (!nextErrors.lwh_qty_packaging) nextErrors.lwh_qty_packaging = [];
      if (!nextErrors.lwh_qty_packaging[indx])
        nextErrors.lwh_qty_packaging[indx] = {};

      nextErrors.lwh_qty_packaging[indx][field_name] = errorMsg;

      return nextErrors;
    });
  };

  const handleCbppTypeChange = (cbppVal) => {
    const cbpp_val = cbppVal.value;
    setSelectedCbpp(cbppVal);
    setFormData((prev) => {
      return {
        ...prev,
        cbpp: cbpp_val
      }
    })
  };

  useEffect(() => {
    return () => {
      Object.values(file2).forEach(({ path }) => {
        if (path?.startsWith("blob:")) URL.revokeObjectURL(path);
      });
    };
  }, []);

  useEffect(() => {
    fetchCountries();
  }, []);

  const styleError = {
    display: "block",
  };

  return (
    <>
      <form onSubmit={handleLogisticInquirySubmit}>
        <div className="row">
          <div className="col-sm-12 mb-3 inquiry-info-labal popup">
            <h3> Contact Information</h3>
          </div>

          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Company Name</label>
              <div className="input-pad logistic-inquery-popup">
                <InputField
                  name="company_name"
                  className="form-control"
                  autoComplete="off"
                  placeholder="Enter company name"
                  onChange={handleChange}
                  value={formData.company_name}
                  onBlur={handleFocusOut}
                  readOnly={
                    isSuperAdmin || isViewer || isInqUser ? false : true
                  }
                  // disabled={user && user.company_name}
                />

                {errors.company_name && (
                  <span className="company-required" style={styleError}>
                    {errors.company_name}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Contact Person</label>
              <div className="input-pad logistic-inquery-popup">
                <InputField
                  type="text"
                  name="contact_person"
                  value={formData.contact_person}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter contact person"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                  readOnly={
                    isSuperAdmin || isViewer || isInqUser ? false : true
                  }
                  // disabled={user && user.name}
                />
                {errors.contact_person && (
                  <span className="company-required" style={styleError}>
                    {errors.contact_person}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-6 ">
            <div className="input-group">
              <label className="form-label required">Email</label>
              <div className="input-pad logistic-inquery-popup">
                <InputField
                  type="text"
                  name="email"
                  //className="form-control"
                  value={formData.email}
                  autoComplete="off"
                  placeholder="Enter email"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                  readOnly={
                    isSuperAdmin || isViewer || isInqUser ? false : true
                  }
                  // disabled={user && user.email}
                />
                {errors.email && (
                  <span className="company-required" style={styleError}>
                    {errors.email}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-6 ">
            <div className="input-wrape">
              <label className="form-label">Phone Number</label>
              <div className="input-pad">
                <PhoneInput
                  id="contact-form-phone"
                  className="form-control inquiry-phone inp-font-size border-dropdown company-representive-border outer_pages_phone_input"
                  name="phone"
                  international
                  limitMaxLength
                  placeholder="Enter phone number"
                  autoComplete="off"
                  value={phoneValue}
                  onChange={handlePhoneChange}
                  onBlur={handleFocusOut}
                />
                {errors.phone && (
                  <span className="company-required" style={styleError}>
                    {errors.phone}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-12 mb-3 inquiry-info-labal popup">
            <h3>Inquiry Information</h3>
          </div>

          <div className={`col-sm-6`}>
            <div className="input-group">
              <label className="form-label required">Freight type</label>
              <div className="input-pad">
                <Select
                  name="freight_type"
                  options={freightTypeList}
                  value={selectedFreightType}
                  onChange={handleFreightTypeChange}
                  placeholder="Select freight type"
                  className="dd-pad"
                  noOptionsMessage={() => "No Freight Type Found"}
                  onBlur={handleFocusOut}
                />
                {errors.freight_type && (
                  <span className="company-required" style={styleError}>
                    {errors.freight_type}
                  </span>
                )}
              </div>
            </div>
          </div>

          {(isEmpty(selectedFreightType) ||
            (selectedFreightType && selectedFreightType.value == "Air")) && (
            <AirFreight
              errors={errors}
              styleError={styleError}
              formData={formData}
              handleFocusOut={handleFocusOut}
              handleCountryFromChange={handleCountryFromChange}
              handleCountryToChange={handleCountryToChange}
              handleTermChange={handleTermChange}
              handleChange={handleChange}
              showPickupAddress={showPickupAddress}
              showDeliveryAddress={showDeliveryAddress}
              countries={countryList}
              selectedTerm={selectedTerm}
              selectedCountryFrom={selectedCountryFrom}
              selectedCountryTo={selectedCountryTo}
              handleFieldAddClick={handleFieldAddClick}
              handleFieldRemoveClick={handleFieldRemoveClick}
              handleLQPChange={handleLQPChange}
              handleLQPcbppChange={handleLQPcbppChange}
              handleLQPFocusOut={handleLQPFocusOut}
            />
          )}

          {!isEmpty(selectedFreightType) &&
            selectedFreightType.value == "Road" && (
              <RoadFreight
                errors={errors}
                styleError={styleError}
                formData={formData}
                handleFocusOut={handleFocusOut}
                handleCountryFromChange={handleCountryFromChange}
                handleCountryToChange={handleCountryToChange}
                handleTermChange={handleTermChange}
                handleChange={handleChange}
                showPickupAddress={showPickupAddress}
                showDeliveryAddress={showDeliveryAddress}
                countries={countryList}
                selectedTerm={selectedTerm}
                selectedCountryFrom={selectedCountryFrom}
                selectedCountryTo={selectedCountryTo}
                handlePortOfOriginChange={handlePortOfOriginChange}
                handleOriginPortInputChange={handleInputChange}
                portOfOriginList={portOfOriginList}
                selectedPortOfOrigin={selectedPortOfOrigin}
                originLoader={originLoader}
                handlePortOfDestinationChange={handlePortOfDestinationChange}
                handleDestinationPortInputChange={handleDestinationInputChange}
                portOfDestinationList={portOfDestinationList}
                selectedPortOfDestination={selectedPortOfDestination}
                destinationLoader={destinationLoader}
                validatePortInput={validatePortInput}
                selectedOceanType={selectedOceanType}
                handleOceanTypeChange={handleOceanTypeChange}
              />
            )}
          {!isEmpty(selectedFreightType) &&
            selectedFreightType.value == "DAP" && (
              <DAPFreight
                errors={errors}
                styleError={styleError}
                formData={formData}
                handleFocusOut={handleFocusOut}
                handleCountryFromChange={handleCountryFromChange}
                handleCountryToChange={handleCountryToChange}
                handleChange={handleChange}
                countries={countryList}
                selectedCountryFrom={selectedCountryFrom}
                selectedCountryTo={selectedCountryTo}
                handlePortOfOriginChange={handlePortOfOriginChange}
                handleOriginPortInputChange={handleInputChange}
                portOfOriginList={portOfOriginList}
                selectedPortOfOrigin={selectedPortOfOrigin}
                originLoader={originLoader}
                handlePortOfDestinationChange={handlePortOfDestinationChange}
                handleDestinationPortInputChange={handleDestinationInputChange}
                portOfDestinationList={portOfDestinationList}
                selectedPortOfDestination={selectedPortOfDestination}
                destinationLoader={destinationLoader}
                validatePortInput={validatePortInput}
                selectedOceanType={selectedOceanType}
                handleOceanTypeChange={handleOceanTypeChange}
                handleCbppTypeChange={handleCbppTypeChange}
                selectedCbpp={selectedCbpp}
              />
            )}
          {!isEmpty(selectedFreightType) &&
            selectedFreightType.value == "Ocean" && (
              <SeaFreight
                errors={errors}
                styleError={styleError}
                formData={formData}
                handleFocusOut={handleFocusOut}
                handleCountryFromChange={handleCountryFromChange}
                handleCountryToChange={handleCountryToChange}
                handleTermChange={handleTermChange}
                handleChange={handleChange}
                showPickupAddress={showPickupAddress}
                showDeliveryAddress={showDeliveryAddress}
                countries={countryList}
                selectedTerm={selectedTerm}
                selectedCountryFrom={selectedCountryFrom}
                selectedCountryTo={selectedCountryTo}
                handlePortOfOriginChange={handlePortOfOriginChange}
                handleOriginPortInputChange={handleInputChange}
                portOfOriginList={portOfOriginList}
                selectedPortOfOrigin={selectedPortOfOrigin}
                originLoader={originLoader}
                handlePortOfDestinationChange={handlePortOfDestinationChange}
                handleDestinationPortInputChange={handleDestinationInputChange}
                portOfDestinationList={portOfDestinationList}
                selectedPortOfDestination={selectedPortOfDestination}
                destinationLoader={destinationLoader}
                validatePortInput={validatePortInput}
                selectedOceanType={selectedOceanType}
                handleOceanTypeChange={handleOceanTypeChange}
                handleCbppTypeChange={handleCbppTypeChange}
                selectedCbpp={selectedCbpp}
              />
            )}

          <div className="col-12">
            <div className="input-wrape inquiry-ck-editer">
              <label
                className="form-label inquiry-text"
                for="contact-form-message"
              >
                Remarks
              </label>
              <div className="input-pad">
                {/* <textarea
                                id="contact-form-message"
                                className="form-control"
                                rows="3"
                                placeholder="Remarks...."
                                name="message"
                                value={formData.message}
                                onChange={handleChange}

                            ></textarea> */}

                <CKEditor
                  editor={ClassicEditor}
                  data={formData.message || ""}
                  config={{
                    toolbar: {
                      items: [
                        "bold",
                        "italic",
                        "underline",
                        "fontSize",
                        "bulletedList",
                        "insertTable",
                      ],
                    },
                    fontSize: {
                      options: [10, 12, 14, "default", 18, 20, 22, 24, 30],
                      supportAllValues: false,
                    },
                    language: "en",
                    plugins: [
                      Essentials,
                      Bold,
                      Italic,
                      Underline,
                      FontSize,
                      Paragraph,
                      List,
                      Table,
                      TableToolbar,
                      TableProperties,
                      TableCellProperties,
                      TableColumnResize,
                    ],
                    table: {
                      contentToolbar: [
                        "tableColumn",
                        "tableRow",
                        "mergeTableCells",
                        "tableProperties",
                        "tableCellProperties",
                      ],
                    },
                    licenseKey: "GPL",
                    // licenseKey: "",
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setFormData((prev) => ({
                      ...prev,
                      message: data,
                    }));
                  }}
                  onReady={(editor) => {
                    editor.editing.view.change((writer) => {
                      writer.setStyle(
                        "height",
                        "150px",
                        editor.editing.view.document.getRoot(),
                      );
                      writer.setStyle(
                        "width",
                        "100",
                        editor.editing.view.document.getRoot(),
                      );
                    });
                  }}
                />
                {errors.message && (
                  <span className="company-required" style={styleError}>
                    {errors.message}
                  </span>
                )}
              </div>
            </div>
          </div>

          {user && isDemoUser && (
            <>
              <div className="col-sm-12 mb-3 inquiry-info-labal popup">
                <h3></h3>
              </div>
              <div className="col-md-12 ">
                <label className="form-label required">Recipient Email</label>{" "}
                <InputField
                  name="emailIds"
                  type="text"
                  value={formData.emailIds}
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
                <em>(Multiple emails can be added using comma separated)</em>
              </div>
              {errors.emailIds && (
                <span className="company-required" style={styleError}>
                  {errors.emailIds}
                </span>
              )}
            </>
          )}

          {(isSuperAdmin || isInqUser || isEndUser) &&
            inqType != "REQ_MOCK_INQ" && (
              <div className="row my-3">
                {FILE_SLOTS.map((slug) => {
                  const fieldName = `attechment#@${slug}`;
                  const preview = file2[fieldName];
                  return (
                    <div className="col-xl-6 mb-3" key={slug}>
                      <label className="form-label">
                        Attachment {slug.replace("FILE", "")}
                      </label>

                      <Choosefile
                        key={fileInputKey[slug]}
                        ref={fileRefs[slug]}
                        className={`form-control choose-pdf ${verrors2[fieldName] ? "is-invalid" : ""}`}
                        type="file"
                        accept="image/jpeg, image/jpg, image/png, image/webp,
                          application/pdf,
                          application/msword,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                          application/vnd.ms-excel,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          text/csv,
                          .doc, .docx, .xls, .xlsx, .csv"
                        onClick={() => handleFileClick(slug)}
                        onChange={handleChange2}
                        name={fieldName}
                        id={fieldName}
                      />

                      {/* Error message */}
                      {verrors2[fieldName] && (
                        <p className="upload-faild-text my-1">
                          <span className="text-danger fw-bold">
                            {verrors2[fieldName]}
                          </span>
                        </p>
                      )}

                      {/* Image preview */}
                      {preview?.fileType === "image" && (
                        <div className="logistic-image-wrape">
                          <img
                            src={preview.path}
                            alt="Preview"
                            style={style2}
                            className="mt-2 rounded border"
                          />
                          <div
                            className="delete-icon"
                            role="button"
                            title="Remove file"
                            onClick={() => handleRemoveFile(slug)}
                          >
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        </div>
                        // <img
                        //     src={preview.path}
                        //     alt="Preview"
                        //     style={style2}
                        //     className="mt-2 rounded border"
                        // />
                      )}

                      {/* PDF icon */}
                      {preview?.fileType === "pdf" && (
                        <div className="logistic-image-wrape">
                          <img
                            src={pdf}
                            alt="PDF"
                            style={style2}
                            className="mt-2"
                          />
                          <div
                            className="delete-icon"
                            role="button"
                            title="Remove file"
                            onClick={() => handleRemoveFile(slug)}
                          >
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        </div>
                      )}

                      {/*
                                        FIX #2 — compare against 'word' / 'excel', not 'word any' / 'excel any'
                                        */}
                      {preview?.fileType === "word" && (
                        <div className="logistic-image-wrape">
                          <img
                            src={word}
                            alt="Word document"
                            style={style2}
                            className="mt-2"
                          />
                          <div
                            className="delete-icon"
                            role="button"
                            title="Remove file"
                            onClick={() => handleRemoveFile(slug)}
                          >
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        </div>
                      )}

                      {preview?.fileType === "excel" && (
                        <div className="logistic-image-wrape">
                          <img
                            src={excel}
                            alt="Excel / CSV"
                            style={style2}
                            className="mt-2"
                          />
                          <div
                            className="delete-icon"
                            role="button"
                            title="Remove file"
                            onClick={() => handleRemoveFile(slug)}
                          >
                            <i className="fa-regular fa-trash-can text-danger"></i>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}

                <p className="upload-info text-muted">
                  Allowed PDF, JPEG, JPG, PNG, WEBP, Word, Excel Max 2 MB.
                </p>
              </div>
            )}

          {/** Assign Inquiry */}
          {(isSuperAdmin || isInqUser) && inqType != "REQ_MOCK_INQ" && (
            <>
              <p className="d-flex align-items-center">
                <CheckBox
                  onChange={handleCheckboxChange}
                  checked={isChecked}
                  disabled={true}
                />
                <span className="ms-2">Assign Inquiry</span>
              </p>
              {errors.assignInq && (
                <span className="company-required" style={styleError}>
                  {errors.assignInq}
                </span>
              )}
              {isChecked &&
                map(assignCountryCompany, (val, indx) => {
                  return (
                    <div className="row my-3">
                      <div className="col-xl-4">
                        <Select
                          name="country_assign"
                          options={countryList}
                          value={
                            assignCountryCompany[indx].country_id == 0
                              ? null
                              : assignCountryCompany[indx]["country"]
                          }
                          onChange={(e) =>
                            handleAssignCountryChangeByIndex(e, indx)
                          }
                          placeholder="Select country"
                          className="dd-pad"
                          noOptionsMessage={() => "No Country Found"}
                          menuPlacement="top"
                        />
                        {errors.countryCompany && (
                          <span className="company-required" style={styleError}>
                            {errors.countryCompany[indx] &&
                              errors.countryCompany[indx]["country"]}
                          </span>
                        )}
                      </div>
                      <div className="col-xl-6">
                        <Select
                          name="company"
                          options={assignCountryCompany[indx]["companyList"]}
                          onInputChange={(e) =>
                            handleAssignCompanyInputChangeByIndex(e, indx)
                          }
                          value={
                            assignCountryCompany[indx].member_id == 0
                              ? null
                              : assignCountryCompany[indx]["company"]
                          }
                          onChange={(e) =>
                            handleAssignCompanyChangeByIndex(e, indx)
                          }
                          placeholder="Select company"
                          className="dd-pad"
                          noOptionsMessage={() => "No Company Found"}
                          menuPlacement="top"
                          filterOption={customFilter}
                          isLoading={memberOptLoader}
                        />
                        {errors.countryCompany && (
                          <span className="company-required" style={styleError}>
                            {errors.countryCompany[indx] &&
                              errors.countryCompany[indx]["company"]}
                          </span>
                        )}
                      </div>
                      <div className="col-xl-2">
                        <div className="d-flex">
                          <button
                            type="button"
                            onClick={handleAddClick}
                            className="btn outline"
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                          <button
                            type="button"
                            onClick={(e) => handleRemoveClick(e, indx)}
                            className="btn outline"
                          >
                            <i className="fa fa-minus"></i>
                          </button>
                          {/* <button type="button" className="btn outline">
                                                    <i className="fa fa-info"></i>
                                                </button> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </>
          )}

          {(isSuperAdmin || isInqUser) && inqType === "REQ_MOCK_INQ" && (
            <>
              <p className="d-flex align-items-center">
                <CheckBox
                  onChange={handleCheckboxChange}
                  checked={!isChecked}
                />
                <span className="ms-2">Assign Inquiry</span>
              </p>
              {errors.assignInq && (
                <span className="company-required" style={styleError}>
                  {errors.assignInq}
                </span>
              )}
              {!isChecked && (
                <div className="row my-3">
                  <div className="col-xl-6">
                    <Select
                      name="country_assign"
                      options={countryList}
                      value={assignCountry}
                      onChange={handleAssignCountryChange}
                      placeholder="Select country"
                      className="dd-pad"
                      noOptionsMessage={() => "No Country Found"}
                      menuPlacement="top"
                    />
                    {errors.assignCountry && (
                      <span className="company-required" style={styleError}>
                        {errors.assignCountry}
                      </span>
                    )}
                  </div>
                  <div className="col-xl-6">
                    <Select
                      name="company"
                      options={companyList}
                      onInputChange={handleAssignCompanyInputChange}
                      value={assignCompany}
                      onChange={handleAssignCompanyChange}
                      placeholder="Select company"
                      className="dd-pad"
                      noOptionsMessage={() => "No Company Found"}
                      menuPlacement="top"
                      filterOption={customFilter}
                      isLoading={memberOptLoader}
                    />
                    {errors.assignCompany && (
                      <span className="company-required" style={styleError}>
                        {errors.assignCompany}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </>
          )}

          <div className="col-md-12 inquiry-form-btn ">
            {props.pageView === "pop_up" && (
              <ButtonCancell
                className="inq-form-btn"
                type="button"
                // disabled={isButtonDisabled}
                onClick={handleCancelClick}
              >
                {" "}
                Cancel
              </ButtonCancell>
            )}
            <ButtonAdminpanel
              type="submit"
              className="inq-form-btn"
              disabled={isButtonDisabled}
            >
              Send Inquiry
            </ButtonAdminpanel>
          </div>
        </div>
      </form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: () => dispatch(getCountryList()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getCompaniesByCountry: (payload) =>
      dispatch(getCompaniesByCountry(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogisticInquiry);
